import { SecureStorage } from '@aparajita/capacitor-secure-storage';

const REFRESH_TOKEN_KEY = 'refreshToken';

export async function getRefreshToken() {
  try {
    return await SecureStorage.getItem(REFRESH_TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

export async function setRefreshToken(token) {
  if (!token) return;
  try {
    await SecureStorage.setItem(REFRESH_TOKEN_KEY, token);
  } catch (e) {
    // Non-fatal — silent refresh just won't work until next login
  }
}

export async function clearRefreshToken() {
  try {
    await SecureStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch (e) {
    // Already gone / never set
  }
}
